import { Component, Input, Output, ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Customer } from 'src/app/services_autogenerated/generated_services';
import { StripeBilling } from '../../../services_autogenerated/generated_services';
import { BillingProfileEntryComponent } from '../billing-profile-entry/billing-profile-entry.component';

declare var Plaid: any;

@Component({
    selector: 'app-billing-profile-entry-modal',
    templateUrl: './billing-profile-entry-modal.component.html',
    styleUrls: ['./billing-profile-entry-modal.component.css'],
    standalone: false
})
export class BillingProfileEntryModalComponent {

  @ViewChild(BillingProfileEntryComponent) billingProfileEntry: BillingProfileEntryComponent;
  @Input() customer: Customer;
  @Input() stripeBilling: StripeBilling = null;
  @Input() display: boolean = false;
  @Output() emitClose = new EventEmitter();
  @Output() emitUpdatedStripeCustomerId = new EventEmitter<string>();

  isCustomer: boolean;

  constructor() { }

  save() {
    this.billingProfileEntry.save();
  }

  afterSave(stripeCustomerId: string) {
    //if (this.customer.stripeCustomerId) {
      this.emitUpdatedStripeCustomerId.emit(stripeCustomerId);
    //}
  }

  cancel() {
    this.emitClose.emit();
  }
}
